import { render, staticRenderFns } from "./ModalUpdateUser.vue?vue&type=template&id=72a26b7e"
import script from "./ModalUpdateUser.vue?vue&type=script&lang=js"
export * from "./ModalUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports